var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CENTERS",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ebfdfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "buildings",
    transform: "translate(480 194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4266",
    "data-name": "Rectangle 4266",
    width: 44,
    height: 44,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 38.417,
    transform: "translate(2.744 37.042)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9790",
    "data-name": "Path 9790",
    d: "M51.2,63.54V33.355a1.372,1.372,0,0,0-1.372-1.372H33.366a1.372,1.372,0,0,0-1.372,1.372V63.54m32.929,0V44.331a1.372,1.372,0,0,0-1.372-1.372H51.2",
    transform: "translate(-26.507 -26.498)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 5.488,
    transform: "translate(10.975 12.345)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 5.488,
    transform: "translate(13.719 23.322)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 5.488,
    transform: "translate(10.975 30.182)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 2.744,
    transform: "translate(30.184 30.182)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 2.744,
    transform: "translate(30.184 23.322)",
    fill: "none",
    stroke: "#00838d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenters);
export default __webpack_public_path__ + "static/media/CENTERS.c2b79f551d81fb474056443f31339c96.svg";
export { ForwardRef as ReactComponent };